export type RankChartItem = {
    rank: 1 | 2 | 3 | 4 | 5;
    journalName: string;
    publicationCount: number;
    bgColor: string;
    textColor: string;
   
};


export type RankChartData = {
    title: string;
    items: RankChartItem[];
};

type RankChartOptions = {
    rootSelector: string;
    onBarClick?: (journalName: string) => void;
    activeSelectionText?: string | null;
    onClearSelection?: () => void;
};

export class RankChart {
    private $root?: JQuery;

    constructor(private options: RankChartOptions) { }

    init(): void {
        this.$root = $(this.options.rootSelector);

        // prevent duplicate bindings
        this.$root.off('click', '.rank-bar');
        this.wireClearButton();
        this.renderClearButton();
        this.$root.on('click', '.rank-bar', (e) => {
            const journalName = String(
                $(e.currentTarget).attr('data-journal') || ''
            ).trim();

            if (!journalName) return;

            this.options.onBarClick?.(journalName);
        });
    }

    setData(data: RankChartData): void {
        if (!this.$root) this.init();
        if (!this.$root || this.$root.length === 0) return;

        this.$root.find('.rank-chart-title').text(data.title);

        const $list = this.$root.find('.rank-chart-list');
        $list.empty();
       
        if (!data.items || data.items.length === 0) {
           $list.append (`
          <div class="text-muted font-italic font-size12 py-2">
          No Journals found.
            </div>
        `);
         return;
   
    }
        const maxCount = Math.max(
            ...data.items.map(item => item.publicationCount),
            1
        );

        data.items.forEach(item => {
            const rawPercent = (item.publicationCount / maxCount) * 100;

            let fillPercent = 60;

            if (rawPercent >= 95) {
                fillPercent = 100;
            }
            else if (rawPercent >= 85) {
                fillPercent = 90;
            }
            else if (rawPercent >= 70) {
                fillPercent = 80;
            }
            else if (rawPercent >= 50) {
                fillPercent = 70;
            }

            const rowHtml = `
    <div class="rank-chart-item mb-2">
        <div class="rank-chart-journal font-size12 font-weight-500">
            ${this.escapeHtml(item.journalName)}
        </div>

        <button
            type="button"
            class="rank-bar w-100 text-left"
            data-journal="${this.escapeHtml(item.journalName)}"
            title="Filter by ${this.escapeHtml(item.journalName)}"
            style ="border-color: ${this.escapeHtml(item.bgColor)};"
        >
            <div class="rank-bar-fill"
                 style="width: ${fillPercent}%; background-color: ${this.escapeHtml(item.bgColor)};">
                <span class="rank-bar-label"
                      style="color: ${this.escapeHtml(item.textColor)};">
                    ${item.publicationCount} publication${item.publicationCount === 1 ? '' : 's'}
                </span>
            </div>
        </button>
    </div>
`;

            $list.append(rowHtml);
        });
    }

    private escapeHtml(value: string): string {
        return $('<div>').text(value).html();
    }

    setActiveSelection(text: string | null): void {
        this.options.activeSelectionText = text;
        this.renderClearButton();
    }

    private renderClearButton(): void {
        const $header = this.$root.find('.js-card-header');
        const $card = this.$root.closest('.col-20');

        if (!$header.length || !$card.length) return;

        $header.find('.js-clear-selection').remove();

        const text = (this.options.activeSelectionText ?? '').trim();
        if (!text) {
            $card.removeClass('border-select');
            return;
        }

        $card.addClass('border-select');

        $header.append(`
        <button 
                class="clear-btn btn-sm js-clear-selection">
            Clear
        </button>
    `);
    }
    private wireClearButton(): void {
        this.$root
            .off('click.clearSelection', '.js-clear-selection')
            .on('click.clearSelection', '.js-clear-selection', () => {
                this.options.onClearSelection?.();
            });
    }
}